import { useNavigate } from 'react-router'

import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger, DropdownMenuItem } from '@/components/ui/dropdown-menu'
import { Icons } from '@/theme/Images'
import { routes } from '@/data'
import { useState } from 'react'
import { ChevronDown, ChevronUp } from 'lucide-react'

const MobileNavbar = ({ isOpen, setIsOpen }) => {
  const navigate = useNavigate()
  const [selectedNavItems, setSelectedNavItems] = useState([])
  const toggleNavItem = itemName => {
    setSelectedNavItems(prevItems =>
      prevItems.includes(itemName) ? prevItems.filter(i => i !== itemName) : [...prevItems, itemName]
    )
  }

  return (
    <DropdownMenu onOpenChange={d => setIsOpen(d)} modal={true} open={isOpen}>
      <DropdownMenuTrigger asChild>
        {isOpen ? (
          <img src={Icons.boldCloseIcon} alt="icon" className="mr-3 block md:hidden" />
        ) : (
          <img src={Icons.menuIcon} alt="icon" className="mr-3 block md:hidden" />
        )}
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="mt-2 text-white border-none w-dvw rounded-none p-0 md:hidden gap-2 flex flex-col overflow-y-auto shadow-none no-scrollbar"
        style={{
          height: 'calc(100dvh - 72px)',
        }}
      >
        {routes?.map(item => {
          const haveSubRoutes = item?.routes && item?.routes?.length > 0
          const isOpen = selectedNavItems.includes(item?.name)
          return (
            <div key={item?.name} className="flex flex-col">
              <DropdownMenuItem
                id={`${item?.name}-dropdown-item`}
                aria-label={`${item?.name}`}
                onClick={e => {
                  if (haveSubRoutes) {
                    e.preventDefault()
                    toggleNavItem(item?.name)
                  } else navigate(item?.path)
                }}
                className={`flex justify-between px-4 py-3 text-white font-semibold text-lg`}
              >
                {item?.name}
                {haveSubRoutes &&
                  (isOpen ? <ChevronUp size={20} color="white" /> : <ChevronDown size={20} color="white" />)}
              </DropdownMenuItem>
              {haveSubRoutes &&
                isOpen &&
                item?.routes?.map(subItem => (
                  <DropdownMenuItem
                    id={`${subItem?.name}-dropdown-item`}
                    aria-label={`${subItem?.name}`}
                    key={subItem?.name}
                    onClick={() => navigate(subItem?.path)}
                    className={`px-8 py-3 text-neutral-25 font-medium text-base`}
                  >
                    {subItem?.name}
                  </DropdownMenuItem>
                ))}
            </div>
          )
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

MobileNavbar.propTypes = {
  isOpen: Boolean,
  setIsOpen: Function,
}

export default MobileNavbar
